import { Component, Input } from '@angular/core';
import { IconPlusComponent } from '../icon-plus/icon-plus.component';
import { IconMinusComponent } from '../icon-minus/icon-minus.component';

@Component({
  selector: 'app-icon-plus-minus-toggle',
  standalone: true,
  imports: [IconPlusComponent, IconMinusComponent],
  templateUrl: './icon-plus-minus-toggle.component.html',
  styleUrl: './icon-plus-minus-toggle.component.scss',
})
export class IconPlusMinusToggleComponent {
  @Input() isClosed: boolean = true;
  @Input() width: string = '16px';
  @Input() height: string = '16px';
  @Input() color: string = '#fff';
}
